$( '.taxonomy-filter--targeted .taxonomy-filter__select select' ).on( 'change', function () {
	const form = $( this ).closest( 'form' );

	$.ajax( {
		url: form.attr('action'),
		data: form.serialize(),
		type: form.attr('method'),

		success: function ( data ) {
			const target = $( '.taxonomy-filter__select select' ).data( 'target' );

			if (data.length) {
				$( target ).html( data );
			} else {
				$( target ).html(['<div>Ingen treff.</div>']);
			}

			// Fire a custom event on taxonomy filter result element.
			const element = document.querySelector( '.taxonomy-filter__result' );
			element.dispatchEvent( new CustomEvent( 'taxonomy_filter_loaded', {
				bubbles: true,
				detail: new Date()
			} ) );
		}
	} );
} ).first().trigger( 'change' ); // Fire change event only once on load.
